import { render, staticRenderFns } from "./ModalTarifaItem.vue?vue&type=template&id=df102a94"
import script from "./ModalTarifaItem.vue?vue&type=script&lang=js"
export * from "./ModalTarifaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports